// Simple Custom Video Lightbox - No GLightbox dependencies
class HomepageVideoLightbox {
  constructor() {
    this.hasShown = false;
    this.autoCloseTimer = null;
    this.lightboxElement = null;
    this.init();
  }

  init() {
    // Only run on homepage and only once per session
    if (document.body.classList.contains('home') && !this.hasShown) {
      
      // Check if already shown in this session
      if (sessionStorage.getItem('homepage_video_shown')) {
        console.log('Video already shown in this session, skipping');
        return;
      }

      // Check if video file is available
      if (!window.acfVideoData || !window.acfVideoData.videoFile) {
        console.log('No video file found, skipping lightbox');
        return;
      }

      console.log('Simple video lightbox initializing...');
      this.launchOnLoad();
    }
  }

  launchOnLoad() {
    // Launch after 2 seconds
    setTimeout(() => {
      if (!this.hasShown) {
        console.log('Launching simple video lightbox...');
        this.createAndShowLightbox();
      }
    }, 2000);
  }

  createAndShowLightbox() {
    // Create lightbox overlay
    this.lightboxElement = document.createElement('div');
    this.lightboxElement.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.9);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `;

    // Create video container
    const videoContainer = document.createElement('div');
    videoContainer.style.cssText = `
      position: relative;
      max-width: 90vw;
      max-height: 80vh;
      background: #000;
    `;

    // Create video element
    const video = document.createElement('video');
    video.style.cssText = `
      width: 100%;
      height: auto;
      max-height: 80vh;
    `;
    video.src = window.acfVideoData.videoFile;
    video.autoplay = true;
    video.muted = true;
    video.controls = false;
    video.loop = false;
    video.playsInline = true;

    console.log('Creating video with src:', video.src);

    // Add close button
    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '✕';
    closeBtn.style.cssText = `
      position: absolute;
      top: 10px;
      right: 10px;
      background: rgba(255, 255, 255, 0.8);
      border: none;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      cursor: pointer;
      font-size: 20px;
      z-index: 10001;
    `;

    // Add play button (fallback)
    const playBtn = document.createElement('button');
    playBtn.innerHTML = '▶️ PLAY';
    playBtn.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 0, 0, 0.9);
      color: white;
      border: none;
      padding: 15px 25px;
      border-radius: 25px;
      cursor: pointer;
      font-size: 16px;
      z-index: 10001;
      display: none;
    `;

    // Event listeners
    video.addEventListener('loadstart', () => {
      console.log('✅ Video loading started');
    });

    video.addEventListener('canplay', () => {
      console.log('✅ Video can play');
      video.play().catch(error => {
        console.log('❌ Autoplay failed, showing play button:', error);
        playBtn.style.display = 'block';
      });
    });

    video.addEventListener('playing', () => {
      console.log('✅ Video is playing!');
      playBtn.style.display = 'none';
      if (window.acfVideoData.autoClose) {
        this.startAutoCloseTimer();
      }
    });

    video.addEventListener('ended', () => {
      console.log('✅ Video ended');
      this.closeLightbox();
    });

    video.addEventListener('error', (e) => {
      console.log('❌ Video error:', e);
      playBtn.innerHTML = '❌ Video Error';
      playBtn.style.display = 'block';
    });

    // Click handlers
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closeLightbox();
    });

    playBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      video.play().then(() => {
        console.log('✅ Manual play successful');
        playBtn.style.display = 'none';
      });
    });

    this.lightboxElement.addEventListener('click', (e) => {
      if (e.target === this.lightboxElement) {
        this.closeLightbox();
      }
    });

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeLightbox();
      }
    });

    // Assemble and show
    videoContainer.appendChild(video);
    videoContainer.appendChild(closeBtn);
    videoContainer.appendChild(playBtn);
    this.lightboxElement.appendChild(videoContainer);
    document.body.appendChild(this.lightboxElement);

    console.log('✅ Lightbox created and shown');
  }

  startAutoCloseTimer() {
    this.autoCloseTimer = setTimeout(() => {
      console.log('Auto-closing after 10 seconds');
      this.closeLightbox();
    }, 10000);
  }

  closeLightbox() {
    if (this.lightboxElement) {
      document.body.removeChild(this.lightboxElement);
      this.lightboxElement = null;
    }
    
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }

    this.hasShown = true;
    sessionStorage.setItem('homepage_video_shown', 'true');
    console.log('✅ Lightbox closed');
  }

  // Public methods for testing
  resetSession() {
    sessionStorage.removeItem('homepage_video_shown');
    this.hasShown = false;
    console.log('Video session reset');
  }

  launch() {
    if (!this.hasShown) {
      this.createAndShowLightbox();
    }
  }
}

// Initialize when DOM is ready
jQuery(document).ready(() => {
  window.homepageVideoLightbox = new HomepageVideoLightbox();
});

// Console helper functions
window.videoLightboxHelpers = {
  reset: () => {
    if (window.homepageVideoLightbox) {
      window.homepageVideoLightbox.resetSession();
    }
  },
  launch: () => {
    if (window.homepageVideoLightbox) {
      window.homepageVideoLightbox.launch();
    }
  }
};

export default HomepageVideoLightbox;


// WEBPACK FOOTER //
// ./scripts/components/homepage_lightbox.js